$('.paragraph--slider').slick({
    useTransform: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    variableWidth: true,
    // responsive: [
    //   {
    //     breakpoint: 640,
    //     settings: {
    //       centerMode: true,
    //       centerPadding: '0px',
    //       slidesToShow: 3
    //     }
    //   }
    // ]
})

$(window).resize(function(){
    customSlider();
});

$(document).ready(function(){
    customSlider();
});

customSlider();

function customSlider(){
    const $slider = $('.paragraph--slider');

    if($slider.length > 0){
        $slider.find(".image-caption").css("max-width", $(window).width());

        if($(window).width() >= 990){
        const $currentSlide = $slider.find(".slick-current");

            setTimeout(
                function() 
                {
                    $slider.find(".slick-prev").css("left", ($currentSlide.offset().left + 50) + "px" );
                    $slider.find(".slick-next").css("left", ($currentSlide.offset().left + $currentSlide.width() - 100) + "px" );
                }, 500);
        
        }else{
            setTimeout(
                function() 
                {
                    $('.paragraph--slider .slick-prev').addClass('-translate-x-40');
                    $('.paragraph--slider .slick-next').addClass('translate-x-40');
                }, 500);
        }
    }
}